import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import DeleteExam from "../../../../../Controllers/Admin/Exams/DeleteExam";
import GetAllExams from "../../../../../Controllers/Admin/Exams/GetAllExams";
import GetUser from "../../../../../Controllers/Users/GetUser";

export default function ExamListingViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ClassID, setClassID] = useState("");
  const [CourseID, setCourseID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [Refresh, setRefresh] = useState(false);

  const handleRefresh = () => {
    setRefresh(!Refresh);
  };
  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setCourseID(LocationArray.slice(-2, -1)[0]);
    setClassID(LocationArray.slice(-4, -3)[0]);
  }, [location.pathname]);

  const [AuthUser, setAuthUser] = useState();
  const [ExamsArray, setExamsArray] = useState([]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const SchoolsData = await GetAllExams(ClassID, CourseID);
      setExamsArray(SchoolsData);
      setIsLoading(false);
    }
    fetchData();
  }, [ClassID, CourseID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [ExamID, setExamID] = useState("");

  const handleOpenDeleteDialog = (id) => {
    setExamID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteExam(ExamID);
      handleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    CourseID,
    ExamsArray,
    navigate,
    IsLoading,
    AuthUser,
  };
}
